export default __webpack_public_path__ + "static/media/privacy.93acce89.png";